// Generated by purs version 0.15.15
import * as Control_Applicative from "../Control.Applicative/index.js";
import * as Control_Bind from "../Control.Bind/index.js";
import * as Data_Either from "../Data.Either/index.js";
import * as Data_Eq from "../Data.Eq/index.js";
import * as Data_Maybe from "../Data.Maybe/index.js";
import * as Data_Show from "../Data.Show/index.js";
import * as Effect_Aff from "../Effect.Aff/index.js";
import * as Effect_Class from "../Effect.Class/index.js";
import * as Effect_Console from "../Effect.Console/index.js";
import * as Foreign_Generic_Class from "../Foreign.Generic.Class/index.js";
import * as Restaumatic_Countries from "../Restaumatic.Countries/index.js";
import * as Restaumatic_Geocoding_Types_StreetAddress from "../Restaumatic.Geocoding.Types.StreetAddress/index.js";
import * as Restaumatic_Services_Storage from "../Restaumatic.Services.Storage/index.js";
var bind = /* #__PURE__ */ Control_Bind.bind(Effect_Aff.bindAff);
var liftEffect = /* #__PURE__ */ Effect_Class.liftEffect(Effect_Aff.monadEffectAff);
var recordDecode = /* #__PURE__ */ Foreign_Generic_Class.recordDecode();
var decodeRecordCons = /* #__PURE__ */ Foreign_Generic_Class.decodeRecordCons();
var decodeRecordCons1 = /* #__PURE__ */ decodeRecordCons(Foreign_Generic_Class.decodeRecordNil);
var resultsIsSymbol = {
    reflectSymbol: function () {
        return "results";
    }
};
var locationIsSymbol = {
    reflectSymbol: function () {
        return "location";
    }
};
var longitudeIsSymbol = {
    reflectSymbol: function () {
        return "longitude";
    }
};
var decodeWithOptionsOther = /* #__PURE__ */ Foreign_Generic_Class.decodeWithOptionsOther(Foreign_Generic_Class.numberDecode);
var latitudeIsSymbol = {
    reflectSymbol: function () {
        return "latitude";
    }
};
var countryIsSymbol = {
    reflectSymbol: function () {
        return "country";
    }
};
var addressIsSymbol = {
    reflectSymbol: function () {
        return "address";
    }
};
var getJSONItem = /* #__PURE__ */ Restaumatic_Services_Storage.getJSONItem()(/* #__PURE__ */ recordDecode(/* #__PURE__ */ decodeRecordCons(/* #__PURE__ */ decodeRecordCons(/* #__PURE__ */ decodeRecordCons1(resultsIsSymbol)(/* #__PURE__ */ Foreign_Generic_Class.decodeWithOptionsRecord()(/* #__PURE__ */ decodeRecordCons1(locationIsSymbol)(/* #__PURE__ */ Foreign_Generic_Class.decodeWithOptionsOther(/* #__PURE__ */ Foreign_Generic_Class.maybeDecode(/* #__PURE__ */ recordDecode(/* #__PURE__ */ decodeRecordCons(/* #__PURE__ */ decodeRecordCons1(longitudeIsSymbol)(decodeWithOptionsOther)())(latitudeIsSymbol)(decodeWithOptionsOther)()))))()))())(countryIsSymbol)(/* #__PURE__ */ Foreign_Generic_Class.decodeWithOptionsOther(Restaumatic_Countries.decodeCountry))())(addressIsSymbol)(/* #__PURE__ */ Foreign_Generic_Class.decodeWithOptionsOther(Restaumatic_Geocoding_Types_StreetAddress.decodeStreetAddress))()));
var eq = /* #__PURE__ */ Data_Eq.eq(Restaumatic_Geocoding_Types_StreetAddress.eqStreetAddress);
var eq1 = /* #__PURE__ */ Data_Eq.eq(Restaumatic_Countries.eqCountry);
var discard = /* #__PURE__ */ Control_Bind.discard(Control_Bind.discardUnit)(Effect_Aff.bindAff);
var show = /* #__PURE__ */ Data_Show.show(Restaumatic_Countries.showCountry);
var show1 = /* #__PURE__ */ Data_Show.show(Restaumatic_Geocoding_Types_StreetAddress.showStreetAddress);
var pure = /* #__PURE__ */ Control_Applicative.pure(Effect_Aff.applicativeAff);
var recordEncode = /* #__PURE__ */ Foreign_Generic_Class.recordEncode();
var encodeRecordCons = /* #__PURE__ */ Foreign_Generic_Class.encodeRecordCons();
var encodeRecordCons1 = /* #__PURE__ */ encodeRecordCons(Foreign_Generic_Class.encodeRecordNil);
var encodeWithOptionsOther = /* #__PURE__ */ Foreign_Generic_Class.encodeWithOptionsOther(Foreign_Generic_Class.numberEncode);
var setJSONItem = /* #__PURE__ */ Restaumatic_Services_Storage.setJSONItem()(/* #__PURE__ */ recordEncode(/* #__PURE__ */ encodeRecordCons(/* #__PURE__ */ encodeRecordCons(/* #__PURE__ */ encodeRecordCons1(resultsIsSymbol)(/* #__PURE__ */ Foreign_Generic_Class.encodeWithOptionsRecord()(/* #__PURE__ */ encodeRecordCons1(locationIsSymbol)(/* #__PURE__ */ Foreign_Generic_Class.encodeWithOptionsOther(/* #__PURE__ */ Foreign_Generic_Class.maybeEncode(/* #__PURE__ */ recordEncode(/* #__PURE__ */ encodeRecordCons(/* #__PURE__ */ encodeRecordCons1(longitudeIsSymbol)(encodeWithOptionsOther))(latitudeIsSymbol)(encodeWithOptionsOther))))))))(countryIsSymbol)(/* #__PURE__ */ Foreign_Generic_Class.encodeWithOptionsOther(Restaumatic_Countries.encodeCountry)))(addressIsSymbol)(/* #__PURE__ */ Foreign_Generic_Class.encodeWithOptionsOther(Restaumatic_Geocoding_Types_StreetAddress.encodeStreetAddress))));
var cachedGeocoding = function (v) {
    return function (next) {
        return {
            geocodeAddress: function (country) {
                return function (address) {
                    return bind(liftEffect(getJSONItem(v.storage)(v.key)))(function (v1) {
                        if (v1 instanceof Data_Maybe.Just && (eq(v1.value0.address)(address) && eq1(v1.value0.country)(country))) {
                            return discard(liftEffect(Effect_Console.log("Geocoding: Using cached result for " + (show(country) + (" " + show1(address))))))(function () {
                                return pure(new Data_Either.Right(v1.value0.results));
                            });
                        };
                        return discard(liftEffect(Effect_Console.log("Geocoding: Cached result not found for " + (show(country) + (" " + show1(address))))))(function () {
                            return bind(next.geocodeAddress(country)(address))(function (response) {
                                if (response instanceof Data_Either.Right) {
                                    return discard(liftEffect(setJSONItem(v.storage)(v.key)({
                                        address: address,
                                        country: country,
                                        results: response.value0
                                    })))(function () {
                                        return pure(new Data_Either.Right(response.value0));
                                    });
                                };
                                return pure(response);
                            });
                        });
                    });
                };
            }
        };
    };
};
export {
    cachedGeocoding
};
